@import '~less/bootstrap/legacy-mixins';
@import '~less/global-variables';

// Small monkeybox directive (users profile in glance)
// Used at message threads
.monkeybox {
  text-align: center;
  font-size: @font-size-small;
  color: @gray;
  .avatar-link {
    .avatar {
      clear: both;
      float: none;
      margin: 0 auto 5px auto;
      max-width: 64px;
      max-height: 64px;
    }
    .avatar-label {
      font-size: @font-size-base;
      display: block;
      margin: 5px auto;
      clear: both;
      float: none;
      font-weight: bold;
    }
  }
  a {
    color: @gray;
    text-decoration: none;
    &:hover,
    &:active {
      text-decoration: underline;
    }
  }
  .monkeybox-section {
    margin: 5px 0;
  }
  h4 {
    .text-muted();
    text-transform: uppercase;
    margin: 3px 0 0 0;
    font-size: 13px;
    line-height: 20px;
    font-weight: normal;
  }
}
